import React from "react";
import { styled } from "@mui/material/styles";
import {
  Route,
  Routes,
} from "react-router-dom";
import HomeComponent from "../Home/Home";
import Subscription from "../Subscription/Subscription";
import Success from "../Subscription/success";
import Failed from "../Subscription/failed";
import { useLocation } from 'react-router-dom';
import Showcase from "../Showcase/Showcase";
import ShowcaseAddModels from "../Showcase/ShowCaseAddModels";
import ShowCaseModalDetails from "../Showcase/ShowcaseModalDetails";
import './MainComponent.css';
import Signup from "../Signup/Signup";
import Verification from "../Verification/Verification";
import ProfileForm from "../Profile/Profile";
import IdeaBoard from "../IdeaBoard/IdeaBoard";
import StudioModels from "../Studio/StudioModels";
import Studio from "../Studio/Studio";
import Cartoon from "../Cartoon/Cartoon";
import CartoonDashboard from "../IdeaBoard/CartoonDashboard";
import ComingSoon from "../Studio/ComingSoon";
import PodCast from "../Studio/PodCast";
import Library from "../Library/Library";
import Receipts from "../MyReceipts/Receipts";
import Usage from "../MyUsage/Usage";
import Notfound from "../NotFound/Notfound";
import Home from "../Home/Home";
import Setting from "../SettingPage/Setting";
import ProductScape from "../ProductScape/ProductScape";
import ChannelSuccess from "../Popup/YouTubePopup/channelSuccess";
import VideoComponent from "../../components/VideoEditorEmbed";
import Rampwalk from "../Rampwalk/Rampwalk";
import Reels from "../../pages/Reels"

// Define types for props
interface MainComponentProps {
  open: boolean;
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `0`,
  overflowY: "auto",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
//   justifyContent: "flex-end",
// }));
// const handleLogout = () => {
//   localStorage.removeItem("accessToken");
//   localStorage.removeItem("refreshToken");
//   localStorage.removeItem("name");
//   window.location.href = "/login";
//   showToast('Logout SuccessFully', "success");
// }

const MainComponent: React.FC<MainComponentProps> = ({ open }) => {
  const location = useLocation();

  return (
    <Main style={{overflow:"hidden"}} className="height-main gradient-background" open={open}>
     {/* {showNavBar && <NavBar />} */}
      <Routes> 
      <Route
          path="/home"
          element={<HomeComponent />}
        />
        {/* <Route
          path="/model/:modelId"
          element={<Model />}
        /> */}
        {/* <Route
          path="/home"
          element={<HomeComponent />}
        /> */}
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Success />} />
        <Route path="/success/:id" element={<Success />} />
        <Route path="/cancel/:id" element={<Failed />} />
        <Route path="/personas" element={<Showcase />} />
        <Route path="/persona/add-model" element={<ShowcaseAddModels />} />
        <Route path="/humanpersona/model/:modelId" element={<ShowCaseModalDetails />} />
         <Route path="/aipersona/model/:modelId" element={<ShowCaseModalDetails />} />
        <Route path="/signup" element={<Signup/>} />
        <Route path='/verify/:verificationId' element={<Verification />} />
        <Route path='/profile' element={<ProfileForm />} />
        <Route path="/idea-board" element={<IdeaBoard />} />
        <Route path='/studio' element={<Studio />} />
        <Route path='/cartoon' element={<Cartoon/>} />
        <Route path='/idea-board/cartoon' element={<CartoonDashboard/>} />
        <Route path='/studio/comingsoon' element={<ComingSoon />} />
        {/* <Route path="/studio" element={<Studio />} /> */}
        <Route path="/studio/cinemotion" element={<StudioModels />} />
        <Route path="/studio/podcast" element={<PodCast key={location.pathname}/>} />
        <Route path="/library" element={<Library />} />
        <Route path="/receipts" element={<Receipts />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/home" element={<Home />} />
         <Route path="/" element={<Home />} />
         <Route path='/comingsoon' element={<ComingSoon />} />
         <Route path="/studio/photo-talks" element={<PodCast />} />
        <Route path="*" element={<Notfound />} />
        <Route path="/idea-board/productscape" element={<ProductScape />} />
        <Route path="/studio/rampwalk" element={<Rampwalk />} />
        <Route path="/studio/reels" element={<Reels />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/idea-board/productscape" element={<ProductScape />} />
        <Route path="/socialmedia/success" element={<ChannelSuccess />} />
        <Route path="/socialmedia/success/:id" element={<ChannelSuccess />} />
        <Route path="/editor" element={<VideoComponent projectId="test" />} />

        {/* <Route path="*" element={<HomeComponent />} /> */}
        {/* <Route path='/persona' element={<Showcase />} /> */}
      </Routes>
    </Main>
  );
};

export default MainComponent;
